import { useMutation } from '@tanstack/react-query';
import { sendLogRegister } from '../api/sendLogRegister';

export const useSendLogRegister = () => {
    return useMutation({
        mutationFn: sendLogRegister,
        retry: false,
    });
};
